import { CaseFlagFilterOptions } from '../../enums/filters-and-searchs/caseflag.filer.options';


export const CaseFlagFilterOptionsDetail = new Map<number, string>([
    [CaseFlagFilterOptions.None, 'None'],
    [CaseFlagFilterOptions.DeletedCaseFlags, 'Deleted Case Flags'],
]);